import {Component, OnInit} from '@angular/core';
import {UIRouter} from '@uirouter/angular';
import {FileService} from './file.service';

@Component({
  selector: 'app-file',
  template: `
     
  `
})
export class FileComponent implements OnInit {

  constructor(
    private router: UIRouter,
    private fileService: FileService
  ) {}

  public ngOnInit(): void {
    window.location.href = this.fileService.getLinkById(this.router.stateService.params.fileId);
  }
}



// WEBPACK FOOTER //
// /var/jenkins_home/workspace/brands-compart-portal-frontend/checkout/src/app/components/file/file.component.ts